import { useState } from "react";
import { api } from "../lib/api";
import { WalletIcon } from "../components/icons";

// Two jobs in one screen:
//   - Normal: username + password sign in. No names shown before you're in.
//   - First run (needsSetup): create the first account, gated by a setup code.
export default function Login({
  needsSetup,
  onSuccess,
}: {
  needsSetup: boolean;
  onSuccess: () => void;
}) {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [setupCode, setSetupCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (needsSetup) {
        await api.setup(setupCode.trim(), name.trim(), username.trim(), password);
      } else {
        await api.login(username.trim(), password);
      }
      onSuccess();
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <div className="login__logo" aria-hidden="true">
            <WalletIcon width={22} height={22} style={{ color: "#fff" }} strokeWidth={1.8} />
          </div>
          <div className="login__brand-text">
            <span className="login__brand-name">Expense Tracker</span>
            <span className="login__brand-sub">
              {needsSetup ? "Create your account" : "Sign in to your household"}
            </span>
          </div>
        </div>

        {needsSetup && (
          <p className="login__hint">
            First-time setup. Enter your setup code and create the first login. This screen disappears once an account exists.
          </p>
        )}

        {needsSetup && (
          <label className="login__field">
            <span className="login__label">Setup code</span>
            <input
              className="input"
              type="password"
              value={setupCode}
              onChange={(e) => setSetupCode(e.target.value)}
              autoComplete="off"
              autoFocus
            />
          </label>
        )}

        {needsSetup && (
          <label className="login__field">
            <span className="login__label">Your name</span>
            <input
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Patrick"
              autoComplete="name"
            />
          </label>
        )}

        <label className="login__field">
          <span className="login__label">Username</span>
          <input
            className="input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus={!needsSetup}
          />
        </label>

        <label className="login__field">
          <span className="login__label">Password</span>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={needsSetup ? "new-password" : "current-password"}
            placeholder={needsSetup ? "At least 8 characters" : "••••••••"}
          />
        </label>

        {error && <p className="login__error" role="alert">{error}</p>}

        <button className="btn btn--primary login__submit" type="submit" disabled={busy}>
          {busy ? "Please wait…" : needsSetup ? "Create account" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
